import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { call, put, select } from 'redux-saga/effects'

import API from '@/api'
import { InternalGa4Actions } from '../actions'
import type { Ga4Property } from '../types'

interface PropertiesResponse {
  properties: Ga4Property[]
}

export function* fetchProperties() {
  const projectId: string | null = yield select(
    migrationProjectSelector.getProjectId
  )

  if (projectId === null) {
    return
  }

  yield put(InternalGa4Actions.propertiesLoading())

  try {
    const response: PropertiesResponse = yield call(
      API.GoogleAnalytics.properties,
      projectId
    )

    yield put(InternalGa4Actions.propertiesLoaded(response.properties))
  } catch {
    yield put(InternalGa4Actions.propertiesLoaded([]))
  }
}
